import { HOST_URL } from 'config';
import GenericApi from '../../common/SearchEntity/api/SearchGenericApi';
import AjaxUtil from '../../../common/Js/AjaxHelper/AjaxUtil';

export default class scannerAPI {
  static stopScanner() {
    var url = HOST_URL + `/WebApp/Scanner/stopScanner`;
    return AjaxUtil.genericSendPost(url, {});
  }

  static startScanner() {
    var url = HOST_URL + `/WebApp/Scanner/StartScanner`;
    return AjaxUtil.genericSendPost(url, {});
  }

  static restartScans() {
    let url = `${HOST_URL}/WebApp/Scanner/RestartScans`;
    return AjaxUtil.genericSendPost(url, {});
  }

  static getScannerHeaderColumns() {
    let data = [
      { field_id: 1 },
      { field_id: 2 },
      { field_id: 3 },
      { field_id: 4 },
      { field_id: 5 },
      { field_id: 6 },
      { field_id: 7 },
      { field_id: 8 }
    ];

    return data;
  }

  static getScannerColumns() {
    let url = `/WebApp/Scanner/GetScannerEntities?`;
    return GenericApi.getSearchColumns(url);
  }

  static initScannerData() {
    let url = `/WebApp/Scanner/GetScannedEndpoints?`;
    return GenericApi.fetchDataInit(url);
  }

  static fetchScannerData(entity, parameters, start, end, orderByDetails) {
    let url = `/WebApp/Scanner/GetScannedEndpoints?`;
    return GenericApi.fetchSearched(url, parameters, start, end, orderByDetails);
  }

  static GetNumberOfScannedHostsSince() {
    var url = HOST_URL + `/WebApp/Scanner/GetNumberOfScannedHostsSince`;
    return AjaxUtil.sendGet(url);
  }

  static exportScansErrorReport() {
    var url = HOST_URL + `/WebApp/Scanner/ExportScansErrorReport`;
    return AjaxUtil.postDownloadFile(url, {});
  }
  static GetScannerStatus() {
    var url = HOST_URL + `/WebApp/Scanner/GetScannerStatus`;
    return AjaxUtil.sendGet(url);
  }
  static autoScanExportToExcel() {
    let url = `${HOST_URL}/WebApp/Scanner/ExportScannerInfoToExcel`;
    return AjaxUtil.postDownloadFile(url, {});
  }

  static autoScanExportUnScannedEndpoints() {
    let url = `${HOST_URL}/WebApp/Scanner/ExportUnScanedEndpointsToExcel`;
    return AjaxUtil.postDownloadFile(url, {});
  }

  static GetHostConnectivityReportByScanId(scanId) {
    var url = HOST_URL + `/WebApp/Scanner/GetHostConnectivityReportByScanId?scanId=${scanId}`;
    return AjaxUtil.sendGet(url);
  }

  /*scan actions */
  static restartScansByScanProgressIds(scanProgressIds) {
    let url = HOST_URL + `/WebApp/Scanner/RescanHostsByScanProgressIds`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ scanProgressIds }));
  }

  static stopScansByScanProgressIds(scanProgressIds) {
    let url = HOST_URL + `/WebApp/Scanner/StopScansPermanentlyByScanProgressIds`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ scanProgressIds }));
  }

  static removeScannerByScanProgressIds(scanProgressIds) {
    let url = HOST_URL + `/WebApp/Scanner/DeleteCynetFilesFromEndpointByScanProgressIds`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ scanProgressIds }));
  }

  static uninstall(scanProgressIds) {
    const url = HOST_URL + `/WebApp/Scanner/Uninstall`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ dbIds: scanProgressIds }));
  }

  static enableReinstall(uninstalledIds) {
    const url = HOST_URL + `/WebApp/Scanner/EnableReinstall`;
    return AjaxUtil.genericSendPost(url, JSON.stringify({ dbIds: uninstalledIds }));
  }

  static generateEPSByGroupName(requestDTO) {
    let url = `${HOST_URL}/WebApp/Scanner/GenerateEPSByGroupAsync`;
    let data = JSON.stringify(requestDTO);
    return AjaxUtil.postDownloadFile(url, data);
  }
  static generateEPSByGroupNameGlobal(requestDTO) {
    let url = `${HOST_URL}/WebAppGlobal/Scanner/GenerateEPSByGroupAsync`;
    let data = JSON.stringify(requestDTO);
    return AjaxUtil.postDownloadFile(url, data);
  }
  static isSiteCreatedAutoDeployAsync(clientId) {
    let url = `${HOST_URL}/WebAppGlobal/Scanner/IsSiteCreatedAutoDeployAsync?clientId=${clientId}`;
    return AjaxUtil.sendGet(url);
  }
}
